module.exports = __webpack_public_path__ + "static/img/process2.50ae507.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/process/process2.jpg
// module id = 3FOt
// module chunks = 0